import React, { useState, useContext } from 'react';
import { endpoints, apiClient } from '../utils/constants';
import ArrowRightWhite from "../assets/icons/svg/arrow-right-line-w.svg";
import { trackEvent } from '../utils/gtmTracker';
import { GlobalContext } from '../globalContext';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [comune, setComune] = useState('');
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false); 
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showErrorModalNewsletter, setShowErrorModalNewsletter] = useState(false);
  const { store, updateStore, t } = useContext(GlobalContext);

  const handleSubmit = (e) => {
    e.preventDefault();

      if (!privacyAccepted) {
        setShowErrorModal(true);
        return;
      }
      
      const payload = {
        
        nome: "",
        cognome: "",
        email: email,
        comune: comune,
        codiceTopCliente: "",
        type: "newsletter_primaria"

      };

      apiClient
        .post(endpoints.subscribeEmailFromNewsletter, payload, false, true)
          .then((responseText) => {
            setShowConfirmation(true);

            if (comune && comune.trim() !== "") {
              trackEvent("newsletter_submit", { comune_newsletter: comune });
            } else {
              trackEvent("newsletter_submit");  
            }
            setEmail('');
            setComune('');
            setPrivacyAccepted(false);
      
        })
        .catch((error) => {
          let errorMessage = error?.message || 'unknown error';
          let statusCode = error?.response?.status;
          let errorString = '';
          if (statusCode) {
            errorString = `${statusCode}: ${errorMessage}`;
          } else {
            errorString = `Code not available: ${errorMessage}`;
          }
          trackEvent("newsletter_error_submit", {
            newsletter_error_submit: errorString
          });
          setShowErrorModalNewsletter(true);
        });
  };

  return (
    <form className="newsletter-form" onSubmit={handleSubmit}>
      <div className="newsletter-wrapper">
      	<div className="newsletter-box">
        	<input
          		type="email"
          		placeholder={t.newsletterPlaceholder}
          		value={email}
          		onChange={(e) => setEmail(e.target.value)}
          		required
        	/>
        </div>
        <button
          type="submit"
          aria-label={t.newsletterButton}
          className="button-newsletter"
        >
          <img src={ArrowRightWhite} alt="Send icon" />
        </button>
      </div>

    {email.length > 0 && (
      <div className="comune-box">
        <input
          type="text"
          placeholder={t.comunePlaceholder}
          value={comune}
          onChange={(e) => setComune(e.target.value)}
        />
      </div>
      )}

      <label className="privacy-label">
        <input
          type="checkbox"
          checked={privacyAccepted}
          onChange={(e) => setPrivacyAccepted(e.target.checked)}
        />
       {t.privacyText}{" "}
        <a
          href="https://www.fibercop.it/informazioni/privacy/"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          {t.privacyLink}
        </a>{" "}
      </label>
      {showConfirmation && (
      	<div className="modal-overlay"
        onClick={() => setShowConfirmation(false)}>
      	
        <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
        <button
              className="modal-close"
              onClick={() => setShowConfirmation(false)}
              aria-label={t.closePopup}
            >
              ✕
            </button>
            <p className="modal-text">
              {t.newsletterSuccess}
            </p>
          </div>
        </div>
      )}
      
      {showErrorModal && (
        <div className="modal-overlay" onClick={() => setShowErrorModal(false)}>
          <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setShowErrorModal(false)}
              aria-label={t.closePopup}
            >
              ✕
            </button>
            <p className="modal-text">
              {t.privacyRequired}
            </p>
          </div>
        </div>
      )}

      {showErrorModalNewsletter && (
        <div className="modal-overlay" onClick={() => setShowErrorModalNewsletter(false)}>
          <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setShowErrorModalNewsletter(false)}
              aria-label={t.closePopup}
            >
              ✕
            </button>
            <p className="modal-text">
              {t.newsletterError}
            </p>
          </div>
        </div>
      )}


    </form>
  );
}
